export default __webpack_public_path__ + "3au0IUc-logout.svg";